import { render, staticRenderFns } from "./custom-modal.vue?vue&type=template&id=f2d67134"
import script from "./custom-modal.vue?vue&type=script&lang=ts"
export * from "./custom-modal.vue?vue&type=script&lang=ts"
import style0 from "./custom-modal.vue?vue&type=style&index=0&id=f2d67134&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports